import styled from 'styled-components';

export const RecipientDetailsWrapper = styled.table`
    width: 100%;

    tr {
        height: 30px;
    }

    .rd-label {
        font-weight: 600;
        text-align: right;
        padding-right: 10px;
        // width: 100px;
    }

    .rd-value {
        // text-align: right;
        width: 50px;
    }
`;

export const AlleleListWrapper = styled.div`

    .allele-list { width:11.1%;float:left;padding:0 4px; }
    .allele-list .label { font-size:12px !important;line-height:16px; }
    .allele-list .badge { font-size:10px !important; }

`;